import React from 'react';
import ErrorPage from '../../containers/Pages/ErrorPage';

interface LocalErrorState {
  hasError: boolean;
}

export function errorBoundry(WrappedComponent) {
  return class extends React.Component<{}, LocalErrorState> {
    constructor(props) {
      super(props);
      this.state = {hasError: false};
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
      this.setState({hasError: true});
      // optional: logToAService
    }

    render() {
      if (this.state.hasError) {
        return (<ErrorPage/>);
      }

      return <WrappedComponent {...this.props} />;
    }
  }
}
